module.exports = __webpack_public_path__ + "static/media/post-img4.51d9e282.jpg";